<template>
    <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand>
            <router-link to="/dashboard">
                <img src="/konametrix.png"
                     class="d-inline-block align-top"
                     alt="Konametrix Logo"
                     width="150px">
            </router-link>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"/>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item v-if="userData.accountStatus != 'P'" id="nav-home" to="/dashboard">Dashboard</b-nav-item>
                <b-nav-item v-if="userData.accountStatus != 'P'" id="nav-profile" to="/alertHistory">Alert History</b-nav-item>
            </b-navbar-nav>
        </b-collapse>

        <b-dropdown size="sm" style="width: 100px; margin: 10px">
            <template v-slot:button-content>Manage</template>
            <b-nav-item v-if="userData.accountStatus != 'P'" id="nav-profile" to="/profile">My Profile</b-nav-item>
            <b-nav-item v-if="userData.accountStatus != 'P' && is_user_admin" id="nav-profile" to="/admin">Account Info</b-nav-item>
            <b-nav-item v-if="userData.accountStatus != 'P' && is_user_admin" id="nav-profile" to="/billing">Service Plan</b-nav-item>
            <b-nav-item v-if="userData.accountStatus != 'P' && is_user_admin" id="nav-profile" to="/alerts">Alerts</b-nav-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-nav-item @click="logOut" id="nav-log-out">Sign Out</b-nav-item>
        </b-dropdown>

    </b-navbar>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import { is_user_admin } from '../helpers/roles'

    export default {

        name: 'k-nav-bar',
        props:{
            userData:{ type: Object, required: true }
        },

        data(){
            return{
                is_user_admin: is_user_admin()
            }
        },

        computed: {

            ...mapState('navBar', {
                searchEnabled: 'searchEnabled',
                filters: 'filters'
            })

        },

        methods:{
            logOut(){ this.$emit('logOut') },

            ...mapActions('navBar', [ 'search' ]),
        }
    }

</script>

<style scoped>

    .logout-link > a {
        font-size: 18px;
        font-weight: bold;
    }

    .md-dropdown >>> button {
        color: #fff;
        background-color: #000000;
        border-color: #000000;
    }

    .bg-dark{
        background-color: #000 !important;
    }

    .navbar {
        height: 80px !important;
    }

    .navbar-dark .navbar-nav .nav-link{
        color: #fff !important;
        font-size: 18px !important;
        font-weight: bold;
        padding-left: 1.2rem !important;
        padding-right: 1.2rem !important;

    }

    .dropdown-title{
        font-size: 10px;
        text-transform: uppercase;
        color: #c9c9c9;
    }
    .icon {
        position: relative;
        width: 28px;
        font-size: 24px;
    }
    .icon {
        top: 0px;
        margin-right: 5px;
        margin-bottom: 10px;
        line-height: 12px;
    }

    .navbar-icon-top .navbar-nav .nav-link > .icon {
        position: relative;
        width: 28px;
        font-size: 24px;
    }
    .navbar-icon-top .navbar-nav .nav-link > .icon {
        top: 0px;
        margin-right: 5px;
        line-height: 12px;
    }
    @media (min-width: 576px) {
        .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }
        .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .icon {
            display: block;
            width: 30px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

    }
    @media (min-width: 768px) {
        .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }
        .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .icon {
            display: block;
            width: 30px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }
    }
    @media (min-width: 992px) {
        .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }
        .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .icon {
            display: block;
            width: 30px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

    }
    @media (min-width: 1200px) {
        .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }

        .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .icon {
            display: block;
            width: 30px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }
    }
</style>


